import React from 'react';
import { Button, red } from 'dma-ui-kit';
import styled from 'styled-components';
import { withRouter } from 'react-router';
import { handleCTA } from 'helpers/handlecta';

const Container = styled.div`
    padding: 0 12px;
    margin-bottom: 10px;

    @media (min-width: 768px) {
        padding: 0 24px;
    }

    @media (min-width: 1024px) {
        padding: 0 48px;
    }
`;

const CTAButton = props => {
    const { history, paragraph } = props;
    const { field_cta_link } = paragraph.attributes;

    const variantName = paragraph.attributes.field_variant ? paragraph.attributes.field_variant : 'tertiary';

    const variant = variantName.endsWith('dark') ? variantName.replace('dark', '') : variantName;
    const dark = variantName.endsWith('dark') ? true : false;

    // Handle CTA links
    const followCTA = () => {
        handleCTA(field_cta_link.uri, history, window);
    };

    return (
        <Container>
            <Button variant={variant} dark={dark} color={red} label={field_cta_link.title} onClick={followCTA} />
        </Container>
    );
};

export default withRouter(CTAButton);
